import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/styles";
import styles from "../../styles/main";
import stylesMembers from "../../styles/members";
import { Typography, Card, Paper } from "@material-ui/core";
import BoxTitle from "../../components/boxTitle";
import classNames from "classnames";
import { unixToTime } from "../../helpers/unix";
import { APP_MODE, APP_MODES } from "../../constants/settings";
import MemberInfoDialog from "../../components/memberInfoDialog";
import { getMostBuyFilters } from "../../services/filters";
import { showInfo, showError } from "../../helpers/notification";
import DetailCard from "../../components/detailCard";
import { Link } from "react-router-dom";
import { dateToPersian, dateTimeToPersian } from "../../helpers/dateToPersian";
import { withSnackbar } from "notistack";
import { initACL } from "../../helpers/acl";

class MostBuyFilters extends Component {
  state = {
    filters: [],
  };

  componentDidMount = async () => {
    getMostBuyFilters()
      .then((data) => {
        if (data.forbidden === true) {
          showError(this.props, "عملیات غیر مجاز");
          return;
        }
        this.setState({ filters: data.mostBuyfilterPurchases });
      })
      .catch((error) => {});
  };

  componentDidUpdate(prevProps, prevState) {
    const result = initACL(this.state.initACL, 0);
    if (result.length > 0) {
      this.setState({
        enableUserInfoButton: result[3],
        initACL: true,
      });
    }
  }

  render() {
    const { classes } = this.props;
    const { filters, enableUserInfoButton } = this.state;
    const { cameras, captures, capturesCount, src } = this.props;

    return (
      <Grid container direction="row" /*className={classes.liveContainer}*/>
        <Grid
          container
          direction="row"
          spacing={2}
          alignItems="stretch"
          alignContent="stretch"
        >
          {filters.map((filter, index) => (
            <Grid key={index} item xs={12}>
              <Card>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  className={classes.memberContent}
                >
                  <Grid
                    item
                    container
                    direction="row"
                    xs={12}
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid
                      item
                      container
                      direction="column"
                      alignItems="flex-end"
                      xs={12}
                      //xs={7}
                      //sm={8}
                      //md={9}
                      //lg={10}
                      spacing={0}
                      style={{ margin: 4 }}
                    >
                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                        spacing={2}
                      >
                        {enableUserInfoButton && (
                          <Grid item>
                            <Link
                              to={{
                                pathname: `/user/search`,
                                userId: filter._id.filtermodeluser_id,
                              }}
                            >
                              <img
                                src={require(`../../images/icon_user.png`)}
                                style={{
                                  width: "18px",
                                }}
                                //className={classes.editIcon}
                                title="اطلاعات کاربر"
                              />
                            </Link>
                          </Grid>
                        )}
                        <Grid item>
                          <Typography
                            className={classes.memberName}
                            variant="subtitle2"
                            style={{ color: "darkblue" }}
                          >
                            {filter._id.filtermodeluser_id}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography variant="body2" className={classes.info}>
                            {filter.count.toLocaleString()}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body2" className={classes.info}>
                            :تعداد فروش
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography variant="body2" className={classes.info}>
                            تومان
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body2" className={classes.info}>
                            {filter.totalAmount.toLocaleString()}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body2" className={classes.info}>
                            :مبلغ کل فروش
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                        style={{ marginTop: "8px" }}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.name}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :نام فیلتر
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.def}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :توضیحات فیلتر
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.info}
                          >
                            تومان
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.price.toLocaleString()}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :قیمت فیلتر
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.filters.length}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :تعداد شرط
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.username}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :نام کاربری
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            {dateTimeToPersian(filter.filtermodel.created_date)}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :تاریخ ساخت فیلتر
                          </Typography>
                        </Grid>
                      </Grid>

                      {filter.filtermodel.change_condition_date && (
                        <Grid
                          item
                          xs={12}
                          container
                          direction="row"
                          justify="flex-end"
                          spacing={1}
                        >
                          <Grid item>
                            <Typography
                              variant="caption"
                              className={classes.memberName}
                            >
                              {dateTimeToPersian(
                                filter.filtermodel.change_condition_date
                              )}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="caption"
                              className={classes.memberName}
                            >
                              :تاریخ تغییر شروط
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography
                            variant="body2"
                            className={classes.memberName}
                          >
                            {filter.filtermodel.share_code}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="caption"
                            className={classes.memberName}
                          >
                            :کد اشتراک
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(withSnackbar(MostBuyFilters));
